import { useContext } from 'react';
import PortfolioIsReadOnlyContext from '@/lib/contexts/PortfolioIsReadOnlyContext';
import PortfolioModeContext from '@/lib/contexts/PortfolioModeContext';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';

// TODO all these mechanisms for determining readonly-ness are confusing
// should be simplified!
const useIsPortfolioReadOnly = (): boolean => {
  const portfolioMode = useContext(PortfolioModeContext);
  const portfolioIsReadonly = useContext(PortfolioIsReadOnlyContext);

  return portfolioIsReadonly || portfolioMode === PortfolioMode.COACH;
};

export default useIsPortfolioReadOnly;
